/**
 * Triggers a browser file download from a Blob or ArrayBuffer.
 */
export function saveFile(
  file: Blob | ArrayBuffer,
  fileName: string,
  fileType: string,
): void {
  const blob = new Blob([file], { type: fileType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
